import { OrcaError } from './OrcaError';

export class ModuleNotFoundError extends OrcaError {
  code = 'MODULE_NOT_FOUND';

  filepath: string;
  parent: string;

  constructor(filepath: string, parent: string) {
    super(`Cannot find module '${filepath}' from '${parent}'`);
    this.parent = parent;
    this.filepath = filepath;
  }
}
